export default function(obj, path, def) {
    def = def ?? undefined;
    const keys = path.split('.');
    let current = obj;
    for (let i = 0; i < keys.length; i++) {
        if (!current.hasOwnProperty(keys[i])) {
            return def;
        }
        current = current[keys[i]];
    }
    return current;
};
